/**
 * dcent-reveal.js — Phase 50 공유 reveal 유틸.
 *
 * 스크롤 진입 시 1회 등장 페이드. `.dcent-reveal` 요소마다 IntersectionObserver를 붙여
 * 뷰포트에 들어오거나(이미 위로 지나간 점프 스크롤 포함) `.dcent-reveal--show`를 더하고
 * 곧바로 disconnect한다(1회성). 소스: ~/work/homepage-design-src/src/useReveal.ts.
 * 모든 bespoke + thin 섹션의 공유 의존이라 이 파일이 먼저 랜딩한다.
 *
 * 전역 상태 0 · 다중 호출 안전. reduced-motion 시 즉시 노출은 CSS(.dcent-reveal @media)가 처리한다.
 * 소스 값 그대로: threshold 0.05, rootMargin "0px 0px 4% 0px".
 *
 * Markup:
 *   <section class="dcent-spec-bento dcent-reveal" ...>…</section>
 */

export function initReveal(root = document) {
  root.querySelectorAll(".dcent-reveal").forEach((el) => {
    const io = new IntersectionObserver(
      ([entry]) => {
        // 진입했거나, 이미 위로 지나간(새로고침/점프 스크롤) 경우 표시
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          el.classList.add("dcent-reveal--show");
          io.disconnect();
        }
      },
      { threshold: 0.05, rootMargin: "0px 0px 4% 0px" },
    );
    io.observe(el);
  });
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  document.addEventListener("DOMContentLoaded", () => initReveal());
  // 테마 편집기가 섹션 DOM을 AJAX 교체할 때 재초기화(라이브 스토어는 미발생). e.target 스코프로 재실행.
  document.addEventListener("shopify:section:load", (e) =>
    initReveal(e.target),
  );
}
